@if (galleryPermissions().can_edit || url()) {
  <app-section-container
    [index]="sectionIndex"
    [gallery]="gallery"
    [section]="section"
    [theme]="theme"
    [galleryPermissions]="galleryPermissions()"
    [darkBackground]="darkBackground"
    [sections]="sections"
    [insideActions]="true"
    [class.dark-gallery-background]="darkBackground"
    (addSection)="addSection.emit($event)"
  >
    <ng-container sectionActionsInside>
      @if (isDesktop()) {
        <div class="spaced-button-group-item">
          <app-context-menu
            [options]="{ width: '320px', noSpacing: true }"
            [position]="'right-out'"
            [verticalPosition]="'auto-in'"
            class="last-button"
            #menu
            name="embed-section-settings"
            contextHoverIdentifier="section-{{ section.id }}"
          >
            <button
              appButton
              name="settings"
              location="edit-embed-section"
              [iconButton]="true"
              height="1"
              shape="round"
              contextButton
              appTooltip="Section Settings"
              toolTipOrigin="left"
              color="simple"
            >
              <app-svg src="/assets/icons/mixer.svg"></app-svg>
            </button>
            <div contextContent>
              <ng-container *ngTemplateOutlet="template"></ng-container>
            </div>
          </app-context-menu>
        </div>
      } @else {
        <app-context-menu
          [options]="{ width: '320px', noSpacing: true }"
          class="last-button"
          #menu
          name="embed-section-settings"
          contextHoverIdentifier="section-{{ section.id }}"
        >
          <button
            appButton
            name="settings"
            location="edit-embed-section"
            height="1"
            fullWidth="true"
            [hasIcon]="true"
            contextButton
            color="simple"
          >
            <app-svg src="/assets/icons/mixer.svg"></app-svg>
            <span>Options</span>
          </button>
          <div contextContent>
            <ng-container *ngTemplateOutlet="template"></ng-container>
          </div>
        </app-context-menu>
      }
    </ng-container>
    <div sectionContent class="embed-container" [class.dark]="darkBackground">
      @if (!url() && galleryPermissions().can_edit) {
        <div class="embed-intro">
          <img
            src="/assets/icons/special/embed-media-{{ darkBackground ? 'light' : 'dark' }}.svg"
            class="embed-icon"
            alt=""
          />
          <h2>Embed Content</h2>
          <p>
            <span
              >Enter the URL or embed code from YouTube, Vimeo, Google Maps, Twitter, Instagram, Facebook or SoundCloud.
            </span>
            <a href="https://help.picflow.com/en/articles/6000973" target="_blank" class="primary-link-opacity"
              >Learn more</a
            >
          </p>
        </div>
        <form [formGroup]="form" (ngSubmit)="update()" class="intro-form">
          <div class="field-and-button">
            <app-input-field [control]="form.controls.url">
              <input type="text" formControlName="url" />
              <label>URL or Code</label>
            </app-input-field>
            <button
              appButton
              name="confirm"
              location="edit-embed-section"
              color="primary"
              spacing="3"
              height="3"
              weight="bold"
            >
              Embed
            </button>
          </div>
        </form>
      }
      <app-embed-display [url]="url()"></app-embed-display>
    </div>
  </app-section-container>
}

<ng-template #template>
  <app-common-section-settings [section]="section" [gallery]="gallery" [theme]="theme">
    <h3 class="menu-list-title">EMBED</h3>
    <form [formGroup]="form" (ngSubmit)="update()">
      <app-input-field [control]="form.controls.url">
        <input type="text" formControlName="url" />
        <label>URL or Code</label>
      </app-input-field>
      <div class="buttons">
        <button
          appButton
          name="update"
          location="edit-embed-section"
          color="primary"
          height="1"
          spacing="3"
          shape="round"
          weight="bold"
        >
          Update
        </button>

        <button
          appButton
          name="reset"
          location="edit-embed-section"
          color="simple"
          height="1"
          [iconButton]="true"
          shape="round"
          (click)="reset()"
          type="button"
        >
          <app-svg src="/assets/icons/undo.svg"></app-svg>
        </button>
      </div>
    </form>
    <div class="divider"></div>
  </app-common-section-settings>
</ng-template>
